export default "__VITE_ASSET__7df4f615__"